import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ControlMessageCategory } from '@/types/category';

import { PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY } from '@/hooks/api/use-category-queries';
import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

async function createCategory(payload: { name: string }) {
  const { data } = await httpClient.post<ControlMessageCategory>(
    API_ROUTES.predefinedMessageCategories.list,
    payload
  );

  return data;
}

export function useCreateCategoryMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY });
    },
  });
}
